<template>
  <div class="row justify-content-center">
    <button
        :disabled="!previousMonthAvailable" class="btn btn-primary"
            @click="previousMonth">
      <svg
          width="1em" height="1em"
          viewBox="0 0 16 16" class="bi bi-chevron-left"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
      </svg>
    </button>
    <div
        class="month look-like-disabled-button m-0 p-2 d-inline-block border border-primary bg-primary rounded text-white">
      {{ currentlySelectedMonth | toMonthNameWithYear }}
    </div>
    <button
        :disabled="!nextMonthAvailable" class="btn btn-primary"
            @click="nextMonth">
      <svg
          width="1em" height="1em"
          viewBox="0 0 16 16" class="bi bi-chevron-right"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    </button>

  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "AdminMonthSelectComponent",

  computed: {
    ...mapGetters({
      nextMonthAvailable:"administrationTimeSheet/nextMonthAvailable",
      previousMonthAvailable:"administrationTimeSheet/previousMonthAvailable",
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
  },
  methods: {
    ...mapActions("administrationTimeSheet",['fetchWorkedCustomerTimesheetWithContractInfo','updateContractAvailability']),
    ...mapMutations({
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth",
    }),
    previousMonth() {
      this.subtractMonth();
      this.fetchNewData();
    },
    nextMonth() {
      this.addMonth();
      this.fetchNewData();
    },
    fetchNewData() {
      this.fetchWorkedCustomerTimesheetWithContractInfo();
      this.updateContractAvailability();
    },
  }
};
</script>

<style scoped>
p {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0;
  margin: 0;
}

button {
  padding: 0.5rem;
}

div {
  margin-bottom: 1rem;
  align-items: center;
}

.month {
  width: 10rem;
}

.look-like-disabled-button {
  opacity: 0.65;
}
</style>